<template>
    <div class="dashbord-galary__item teacher-tab">
        <div class="galary-item__avatar">
            <img class="galary-item__avatar-box" :src="'http://dist.inpsycho.ru/img/avatar/'+userInfo.id+'.jpg'">
        </div>
        <h3 class="galary-item__name">{{userInfo.name}}</h3>
        <p class="galary-item__date-place">Преподаватель</p>
        <div class="galary-item__params">
            <div class="params__item">
                <h4 class="param__title">Сообщения</h4>
                <router-link class="message-btn" to="/messages">
                    <i class="el-icon-message"></i>
                    <span class="message-btn__total">{{teacherData.properties.countUnreadMsg}}</span>
                </router-link>
            </div>
            <div class="params__item">
                <h4 class="param__title">Дисциплины</h4>
                <span class="param__value">{{teacherData.properties.countDisciplines}}</span>
            </div>
            <div class="params__item">
                <h4 class="param__title">Работы</h4>
                <span class="param__value">{{teacherData.properties.countUntestedWorks}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        teacherData:Object
    },
    computed:{
        userInfo(){
            return this.$store.state.auth.user
        },
    }
}
</script>

<style lang="scss">
        .teacher-tab{
            border-radius: 40px 0 40px 0;
            padding: 20px;
        }
        .galary-item__avatar{
            position: absolute;
            width: 60px;
            height: 60px;
            margin-right: -30px;
            right: 50%;
            top: -30px;
            border-radius: 50%;
            overflow: hidden;
        }
        .galary-item__avatar-box{
            width: 100%;
            height:100%;
        }
        .galary-item__name{
            text-align: center;
            margin-bottom: 5px;
        }
        .galary-item__date-place{
            margin-top: 0;
            color: $secondary-text-clr;
            text-align: center;
        }
        .galary-item__params{
            padding: 0 8px;
            display: flex;
            justify-content: space-around;
        }
        .params__item{
            width: 33%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .param__title{
            color: $brand-clr-1;
            text-align: center;
            margin-bottom: 10px;
            font-size: 12px;
            margin: 0;
            height: 30px;
            
        }
        .param__value{
            text-align: center;
            margin: 0 auto;
            color: $secondary-text-clr;
            height: 30px;
            font-size: 20px;
            line-height: 30px;
        }
        .message-btn{
            position: relative;
            width: 50px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            i{
                cursor: pointer;
                text-align: center;
                width: 50px;
                font-size: 30px;
                color: $secondary-text-clr;
                &:hover{
                    color: $brand-clr-1;
                }
            }

        }
        .message-btn__total{
            text-align: center;
            line-height: 21px;
            border-radius: 50%;
            color: $basic-white;
            display: block;
            width: 20px;
            height: 20px;
            position: absolute;
            right:0;
            top: -5px;
            background-color: $danger-clr;
            font-size: 12px;
        }
</style>